import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

export const Investors: FC = () => {
  return (
    <>
      <div className="bg-frecDarkBeige grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[auto_1px]">
        <div className="">{/* empty */}</div>
        <div className="dotted-v lg:mx-12 lg:border-x">
          <div className="grid grid-cols-1 lg:grid-cols-[auto_auto]">
            <div className="dotted-v flex items-center justify-start p-6 lg:border-r lg:p-14">
              <h3 className="text-[32px] lg:text-[40px]">Our investors</h3>
            </div>
            <div className="dotted-h col-span-3 border-b lg:hidden">
              {/* empty */}
            </div>
            <div className="flex flex-col items-center justify-around gap-6 p-6 lg:flex-row">
              <div className="flex flex-1 justify-center p-8 lg:p-0">
                <Link href="https://greylock.com" target="_blank">
                  <Image
                    src="/webstatic/svg/greylock-logo.svg"
                    alt="Greylock Partners"
                    width={158}
                    height={40}
                  />
                </Link>
              </div>
              <div className="flex flex-1 flex-col items-center gap-4">
                <p className="text-[14px] font-medium uppercase">
                  And angel investors from
                </p>
                <div className="flex flex-wrap items-center justify-center gap-8 opacity-40">
                  <Image
                    src="/webstatic/svg/google-logo.svg"
                    alt="Google"
                    width={90}
                    height={35}
                  />
                  <Image
                    src="/webstatic/svg/meta-logo.svg"
                    alt="Meta"
                    width={100}
                    height={35}
                  />
                  <Image
                    src="/webstatic/svg/brex-logo.svg"
                    alt="Brex"
                    width={90}
                    height={35}
                  />
                  <Image
                    className="mt-2"
                    src="/webstatic/svg/angellist-logo.svg"
                    alt="Angellist"
                    width={120}
                    height={35}
                  />
                  <Image
                    src="/webstatic/svg/apple-logo.svg"
                    alt="Apple"
                    width={35}
                    height={35}
                  />
                  <Image
                    className="mt-1"
                    src="/webstatic/svg/instacart-logo.svg"
                    alt="Instacart"
                    width={120}
                    height={35}
                  />
                </div>
              </div>
              {/* <Link href="https://neo.com" target="_blank">
                <Image
                  className="mb-2"
                  src="/webstatic/svg/neo-logo.svg"
                  alt="Neo"
                  width={85}
                  height={40}
                />
              </Link> */}
              {/* <Link href="https://www.socialleverage.com/" target="_blank">
                <Image
                  src="/webstatic/svg/social-leverage-logo.svg"
                  alt="Social Leverage"
                  width={318}
                  height={40}
                />
              </Link> */}
            </div>
          </div>
        </div>
        <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
      </div>
    </>
  );
};
